import React from "react";
import { SectionHeaderContainer } from "../component/styled";

const SectionHeader = ({ title, subtitle = null, action = null, withLine = false }) => {
  const getClassName = () => {
    return [withLine && "line", action && "btn"].filter(Boolean).join(" ");
  };

  return (
    <SectionHeaderContainer className={getClassName()}>
      <div className="tit">
        <strong>{title}</strong>
        {subtitle &&
          (subtitle.clickEvent ? (
            <button type="button" onClick={subtitle.clickEvent}>
              {subtitle.label}
              {subtitle.icon && <subtitle.icon />}
            </button>
          ) : (
            <span>
              {subtitle.icon && <subtitle.icon />}
              {subtitle.label}
            </span>
          ))}
      </div>
      {action && (
        <button onClick={() => action.clickEvent()} className={action?.className || ""}>
          {action.label && action.label}
          {action.icon && <action.icon />}
        </button>
      )}
    </SectionHeaderContainer>
  );
};

export default SectionHeader;
